import React, { Component } from "react";
import RegistrationContent from "../registration/RegistrationContent";
import { Col, Row } from "reactstrap";
import PropTypes from "prop-types";
import { i18n } from "../../i18n/i18n";
import { withLang } from "../../i18n/withLang";

class ProcessLoginError extends Component<any> {
  static formName = "ProcessLoginForm";
  static propTypes = {
    zpusobRegistrace: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    values: PropTypes.array,
    errors: PropTypes.array,
  };

  renderRowValue(vaule) {
    const { errors } = this.props;
    return (
      (vaule.key !== "urovenDuveryhodnosti" || (vaule.key === "urovenDuveryhodnosti" && errors[vaule.key])) && (
        <Row noGutters>
          <Col xs={4}>{vaule.name}:</Col>
          <Col xs={8}>
            {errors[vaule.key] ? (
              <span className={"text-danger"}>{errors[vaule.key]}</span>
            ) : (
              <span className={"text-success"}>{i18n(this.props.lang, "ProcessLoginPage_predano")}</span>
            )}
          </Col>
        </Row>
      )
    );
  }

  render() {
    const { values, errors, description, zpusobRegistrace } = this.props;
    return (
      <RegistrationContent betweenBorder={false}>
        <Row>
          <Col>
            <h2 className={"font-weight-bold"}>{i18n(this.props.lang, "ProcessLoginPage_chybaPrihlaseni")}</h2>
          </Col>
        </Row>
        <Row>
          <Col>{description}</Col>
        </Row>
        {values && errors && values.map((vaule) => this.renderRowValue(vaule))}
        <Row className={"mt-4 "}>
          <Col xs={4} className={"text-right"}>
            <a href={(window as any).appConfig.serverContextPath + "/registrace/failure/retry?typ=" + zpusobRegistrace}>
              {i18n(this.props.lang, "ProcessLoginPage_action_opakovatPrihlaseni")}
            </a>
          </Col>
          <Col xs={8} className={"border-left"}>
            <a href={(window as any).appConfig.serverContextPath + "/registrace/failure/new"}>
              {i18n(this.props.lang, "ProcessLoginPage_action_zmenitPrihlaseni")}
            </a>
          </Col>
        </Row>
      </RegistrationContent>
    );
  }
}

export default withLang(ProcessLoginError);
